import React, { useEffect } from "react";
import * as yup from "yup";
import { Button, message, Modal } from "antd";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import BulkPMSReportCreationTable from "./BulkPMSReportCreationTable";
import { PmsReportSchema } from "../../../schema/pmsReport.schema";
import { useBulkCreationPMSReport } from "../../../hooks/pms.hooks";

const getBulkPMSReportUploadSchema = () => {
  return yup.object({
    formData: yup.array().of(PmsReportSchema),
  });
};

const BulkPMSReportFormElement = ({ reportData, setOpen }) => {
  const { mutate: addBulkPMSReport, isLoading: addReportLoading } =
    useBulkCreationPMSReport({
      onSuccess: () => {
        message.success("PMS Reports Created Successfully");
        setOpen(null);
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "Server Error", 5);
      },
    });

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      formData: reportData,
    },
    resolver: yupResolver(getBulkPMSReportUploadSchema()),
  });
  const { fields, remove, replace } = useFieldArray({
    control,
    name: "formData",
  });

  const onSubmit = async (data) => {
    const { formData } = data;
    addBulkPMSReport({ reportData: formData });
  };

  useEffect(() => {
    reset({
      data: "formData",
    });
    replace(reportData);
  }, [reportData]);

  const onCancelHandler = () => {
    reset();
    setOpen(null);
  };

  return (
    <Modal
      className="addReportModal"
      title="Add Bulk PMS Report"
      width={1200}
      open={reportData?.length >0 }
      footer={null}
      onCancel={onCancelHandler}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <BulkPMSReportCreationTable
          dataSource={fields}
          errors={errors}
          control={control}
          watch={watch}
          remove={remove}
        />
        <div style={{ textAlign: "center", paddingTop: "20px" }}>
          <Button
            type="primary"
            disabled={fields.length === 0}
            htmlType="submit"
            loading={addReportLoading}
          >
            Process
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default BulkPMSReportFormElement;
